import { render, staticRenderFns } from "./NarrowLoader.vue?vue&type=template&id=e74d1068&"
import script from "./NarrowLoader.vue?vue&type=script&lang=js&"
export * from "./NarrowLoader.vue?vue&type=script&lang=js&"
import style0 from "./NarrowLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports